import * as React from 'react';
import { ISidebarPanelTitle } from './interfaces';
import { Typography } from '@mui/material';

export const SidebarPanelTitle: React.FC<ISidebarPanelTitle> = ({
  title,
  sx,
}): JSX.Element => {
  return (
    <Typography
      variant="body2"
      fontWeight="bold"
      // color="primary.main"
      fontSize="1rem"
      sx={{
        mb: '5px',
        ...sx,
      }}
    >
      {title}
    </Typography>
  );
};
